// Import model
import { RelatedObjectsFieldOptions } from '../models/RelatedObjectsFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for RelatedObjectsFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class RelatedObjectsFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a RelatedObjectsFieldOptions instance
   */
  static deserialize(json: string): RelatedObjectsFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a RelatedObjectsFieldOptions instance
   */
  static fromObject(obj: any): RelatedObjectsFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to RelatedObjectsFieldOptions');
    }


    const instance: RelatedObjectsFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _2B798Cab: obj['_2b798cab'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of RelatedObjectsFieldOptions instances
   */
  static deserializeArray(json: string): RelatedObjectsFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a RelatedObjectsFieldOptions instance to a JSON string
   */
  static serialize(instance: RelatedObjectsFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a RelatedObjectsFieldOptions instance to a plain object
   */
  static toObject(instance: RelatedObjectsFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_2b798cab': instance._2B798Cab,
    };
  }

  /**
   * Serializes an array of RelatedObjectsFieldOptions instances to a JSON string
   */
  static serializeArray(instances: RelatedObjectsFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
